import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WhyUs.css';

const features = [
  {
    title: 'Индивидуальные маршруты',
    text: 'Создаём поездки под ваши интересы: от пляжного отдыха до эксклюзивных туров и VIP-сервиса.',
  },
  {
    title: 'Полное сопровождение',
    text: 'Бронирование отелей, трансферы, страховка, визы и персональные гиды — всё в одном месте.',
  },
  {
    title: 'Проверенные партнёры',
    text: 'Работаем с надёжными авиакомпаниями, отелями и туроператорами по всему миру.',
  },
  {
    title: 'Поддержка 24/7',
    text: 'Менеджеры на связи до, во время и после поездки. Поможем решить любой вопрос.',
  },
];

function WhyUs() {
  const navigate = useNavigate();

  return (
    <section className="why-us-section page-section">
      <div className="page-container">
        <h2 className="section-title">Почему выбирают Asian Tour</h2>
        <p className="section-subtitle">
          Мы делаем путешествия простыми и понятными: от первой консультации до возвращения домой.
        </p>

        <div className="why-us-grid">
          {features.map((item) => (
            <article key={item.title} className="why-us-card">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>

        <div className="why-us-cta">
          <button className="btn-primary" onClick={() => navigate('/book')}>
            Оставить заявку на поездку
          </button>
          <button className="btn-secondary" onClick={() => navigate('/why')}>
            Подробнее о нас
          </button>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
